import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const useCallEmbedParliamentLive = (props) => {
  const { parliamentLiveReferenceDates, eventApiCall, condition } = props ?? {};
  const topicParam = getUrlParam('topic-id');
  const searchParam = getUrlParam('search') ?? getUrlParam('or');

  const defaultInterval = 30000; //ms

  const minutesPerCallParam = getUrlParam('minutesPerCall');
  const minutesPerCall = minutesPerCallParam ?? defaultInterval / 60000;
  const interval = minutesPerCallParam ? 60000 : defaultInterval;
  const [date, setDate] = useState(null);
  const intervallCallFunction = useRef(null);
  intervallCallFunction.current = async ({ source }) => {
    try {
      const { initialCallSecondDateValue } = parliamentLiveReferenceDates;
      const dateValue = date ?? initialCallSecondDateValue;
      const secondValue = dayjs(date ?? initialCallSecondDateValue)
        .add(minutesPerCall, 'minute')
        .format('YYYY-MM-DDTHH:mm:ss');

      const newDateFilter = {
        field: 'createdAtUtc',
        value: dateValue,
        operator: 'DATE_GTE',
      };

      const filters = [
        newDateFilter,
        {
          field: 'createdAtUtc',
          value: secondValue,
          operator: 'date_lt',
        },
      ];
      await eventApiCall({
        filters,
        source,
      });
      setDate(secondValue);
    } catch (error) {}
  };
  const intervalFunc = useRef(null);

  useEffect(() => {
    const source = new AbortController();
    if (condition) {
      intervalFunc.current = setInterval(() => intervallCallFunction.current({ source }), interval);
    }
    return () => {
      if (!!source) {
        source.abort('New ParliamentLive call canceled by the user.');
      }
      if (!!intervalFunc.current) {
        clearInterval(intervalFunc.current);
      }
      setDate(null);
    };
  }, [condition, topicParam, searchParam]);
};

export default useCallEmbedParliamentLive;
